import React, { useState } from "react";
import FormComponent from "./FormComponent";
import { Form } from "antd";
import {
  dataToFormDataConverter,
  Notification,
} from "../../../../config/Global";
import { CONSTANT } from "../../../../config/Constant";

const EditComponent: React.FC<any> = (props) => {
  const { visible, close, editData, companies, getList } = props;
  const [form] = Form.useForm();

  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const authToken = localStorage.getItem("token");

  var myHeaders = new Headers();
  myHeaders.append("Authorization", authToken ? authToken : "");

  const handleSubmit = async (data?: any) => {
    setLoading(true);
    const newObj = {};
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        newObj[key] = data[key] === undefined ? "" : data[key];
      }
    }

    const payload = {
      ...newObj,
      id: editData?._id,
    };

    const formData = dataToFormDataConverter(payload);

    if (fileList.length > 0) {
      formData.append("file", fileList[0]?.originFileObj);
    }
    try {
      const response = await fetch(
        `${CONSTANT.BASE_URL}/company_number/update`,
        {
          method: "POST",
          body: formData,
          headers: myHeaders,
        }
      );
      const responseData = await response.json();

      if (response.ok) {
        form.resetFields();
        getList();
        handleClose();
        setFileList([]);
        setLoading(false);
        // console.log('File uploaded successfully!');
        Notification.success({
          message: "File uploaded successfully.",
        });
      } else {
        if (responseData.notification) {
          Notification.error({
            message: responseData.notification.join(", "), // Combine messages into a single string
          });
        }
      }
    } catch (error) {
      setLoading(false);
      // console.log('File upload failed.');
      console.error("Error uploading file:", error);
      Notification.error({
        message: "File upload failed.",
      });
    }
  };

  const handleClose = () => {
    close();
    form.resetFields();
  };

  return (
    <>
      <FormComponent
        handleSubmit={handleSubmit}
        form={form}
        visible={visible}
        close={handleClose}
        title={"Edit Company Number Management"}
        loading={loading}
        setFileList={setFileList}
        type="Edit"
        companies={companies}
        editData={editData}
      />
    </>
  );
};

export default EditComponent;
